import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisabledTextModule } from '@shared/core/components/disabledText';
import { FormForLinkAccountRewardsModule } from '@shared/core/modules/forms/formTypes/forLinkRewardsAccount';

import { AuthComponentsModule } from '../../components';

import { AuthForRewardsAccountLinkingSignUpComponent } from './auth-for-rewards-account-linking-sign-up.shared.component';


@NgModule({
    declarations: [
        AuthForRewardsAccountLinkingSignUpComponent
    ],
    imports: [
        CommonModule,
        AuthComponentsModule,
        DisabledTextModule,
        FormForLinkAccountRewardsModule,
    ],
    exports: [
        AuthForRewardsAccountLinkingSignUpComponent
    ]
})
export class AuthForRewardsAccountLinkingSignUpModule { }
